export const getAdditionalFormFieldsEnv = (): boolean => {
  if (!process.env.REACT_APP_ADDITIONAL_FORM_FIELDS) return false;
  return JSON.parse(process.env.REACT_APP_ADDITIONAL_FORM_FIELDS.toLowerCase());
};
